module.exports = __webpack_public_path__ + "assets/ojo.e884c56cf4b4b443c09e19b14c59ecdf.svg";


//////////////////
// WEBPACK FOOTER
// ./img/ojo.svg
// module id = 1005
// module chunks = 0